import React, { useEffect, useState } from 'react'
import cx from 'classnames'
import uuid from 'uuid'
import { USER_ANNOTATIONS_PUBLISHER, USER_ANNOTATIONS_TECH } from 'constants/user-roles'
import CommentEditorContainer from 'redux/containers/components/comments/CommentEditorContainer'

export const translate = label => {
  switch (label) {
    case 'private':
      return 'Private'
    case 'public':
      return 'Firm-wide'
  }
}

const CommentWrapper = ({
  comments = [],
  commentTarget = null,
  commentReference = null,
  commentCategory = null,
  id,
  addComment = true,
  userIs
}) => {
  const [newCommentId, setNewCommentId] = useState(uuid.v1())

  useEffect(() => {
    const requiresNewId = comments.reduce(
      (a, c) => a || c.id === newCommentId,
      false
    )

    if (requiresNewId) {
      setNewCommentId(uuid.v1())
    }
  }, [comments])

  if (!comments || !commentTarget || !commentCategory) {
    return null
  }

  const canChangePrivacy = userIs(USER_ANNOTATIONS_PUBLISHER) || userIs(USER_ANNOTATIONS_TECH)

  return (
    <div
      className={cx(
        'accordion-comments',
        { empty: comments.length === 0 }
      )}
      id={id}
    >
      {comments
        .filter(c => c.active)
        .sort(
          (a, b) =>
            a.dateCreated < b.dateCreated
              ? -1
              : a.dateCreated === b.dateCreated ? 0 : 1
        )
        .map(comment => (
          <CommentEditorContainer
            key={comment.id}
            {...comment}
            {...{ commentTarget, commentReference, commentCategory }}
          />
        ))}
      {addComment && (
        <CommentEditorContainer
          key={newCommentId}
          {...{
            commentTarget,
            commentReference,
            commentCategory,
            id: newCommentId,
            canChangePrivacy
          }}
          newComment
          show={!!comments.length}
          elementId={id + '/new'}
        />
      )}
    </div>
  )
}

export default CommentWrapper
